import React from 'react';
import { get } from '../util/api';

// Cloudflare Turnstile onay kutusu (login). Site key sunucudan gelir (GET /auth/turnstile-config, server env
// TURNSTILE_SITE_KEY); build env REACT_APP_TURNSTILE_SITEKEY verilirse o kullanilir. Key yoksa kutu render edilmez
// ve login eskisi gibi calisir. Token tek kullanimlik: basarisiz denemeden sonra parent `resetKey`'i degistirir.
const BUILD_SITEKEY = process.env.REACT_APP_TURNSTILE_SITEKEY || '';
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

let siteKeyPromise = null;
function fetchSiteKey() {
	if (BUILD_SITEKEY) return Promise.resolve(BUILD_SITEKEY);
	if (!siteKeyPromise)
		siteKeyPromise = get('/auth/turnstile-config')
			// util/api get() cevabin govdesini (resp.data) donduruyor
			.then((body) => (body && (body.siteKey || (body.data && body.data.siteKey))) || '')
			.catch(() => {
				siteKeyPromise = null;
				return '';
			});
	return siteKeyPromise;
}

// undefined: yukleniyor, '': kapali, string: site key
export function useTurnstileSiteKey() {
	const [key, setKey] = React.useState(BUILD_SITEKEY || undefined);
	React.useEffect(() => {
		let alive = true;
		fetchSiteKey().then((k) => alive && setKey(k));
		return () => {
			alive = false;
		};
	}, []);
	return key;
}

let scriptPromise = null;
function loadScript() {
	if (window.turnstile) return Promise.resolve(window.turnstile);
	if (scriptPromise) return scriptPromise;
	scriptPromise = new Promise((resolve, reject) => {
		const s = document.createElement('script');
		s.src = SCRIPT_SRC;
		s.async = true;
		s.defer = true;
		s.onload = () => resolve(window.turnstile);
		s.onerror = (e) => {
			scriptPromise = null;
			reject(e);
		};
		document.head.appendChild(s);
	});
	return scriptPromise;
}

export default function Turnstile({ siteKey, onToken, resetKey, style }) {
	const ref = React.useRef(null);
	React.useEffect(() => {
		if (!siteKey) return undefined;
		let widgetId = null;
		let alive = true;
		onToken('');
		loadScript()
			.then((turnstile) => {
				if (!alive || !ref.current || !turnstile) return;
				widgetId = turnstile.render(ref.current, {
					sitekey: siteKey,
					// normalde gorunmez; Cloudflare dogrulama isterse form genisliginde acik renkli kutu cikar
					theme: 'light',
					size: 'flexible',
					appearance: 'interaction-only',
					callback: (token) => alive && onToken(token),
					'expired-callback': () => alive && onToken(''),
					'error-callback': () => alive && onToken(''),
				});
			})
			.catch(() => alive && onToken(''));
		return () => {
			alive = false;
			if (widgetId !== null && window.turnstile) {
				try {
					window.turnstile.remove(widgetId);
				} catch (e) {
					// widget zaten kaldirilmis olabilir
				}
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resetKey, siteKey]);
	if (!siteKey) return null;
	// interaction-only'de kutu cogu zaman bos kalir; bosken yer kaplamasin diye dikey bosluk yok, kutu cikinca kendi yuksekligi gelir
	return <div ref={ref} style={Object.assign({ width: '100%', marginTop: '8px' }, style)} />;
}
